import { render, staticRenderFns } from "./Screen2FA.vue?vue&type=template&id=15e9a88a&scoped=true&"
import script from "./Screen2FA.vue?vue&type=script&lang=js&"
export * from "./Screen2FA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e9a88a",
  null
  
)

export default component.exports